import { useColorMode } from "@chakra-ui/react";
import { getColor } from "../../brandConfig";

/**
 * Industry design-system roles → brandConfig tokens, resolved for the current
 * colour mode. TalentLink+ is a light-only brand (brandConfig.colorModeLocked)
 * but the getColor(token, colorMode) idiom is kept so the page follows the
 * tenant record if the lock is ever lifted.
 *
 * Role (handoff/tokens.json)          Token
 * page ground (--color-bg)            background.main
 * surface                             background.surface
 * steel field (accent-900)            secondary
 * rule on steel (accent-800)          secondaryHover
 * accent (action colour)              primary
 * small accent text / kickers (700)   primaryHover
 * kicker on steel / tag fill (200)    accentLight
 * text / muted / furniture            text.primary / text.secondary / text.muted
 * reversed type on steel              text.inverse
 * dividers                            border.medium (frames) / border.light (rows)
 * registration marks                  border.dark
 */
export const useIndustry = () => {
  const { colorMode } = useColorMode();
  const c = (path: string) => getColor(path, colorMode);
  return {
    colorMode,
    ground: c("background.main"),
    surface: c("background.surface"),
    steel: c("secondary"),
    steelRule: c("secondaryHover"),
    accent: c("primary"),
    accent700: c("primaryHover"),
    accent200: c("accentLight"),
    text: c("text.primary"),
    muted: c("text.secondary"),
    faint: c("text.muted"),
    inverse: c("text.inverse"),
    rule: c("border.medium"),
    ruleLight: c("border.light"),
    mark: c("border.dark"),
  };
};

/** Kicker: 13px/12px, 600, uppercase, .08em (handoff/components.md). */
export const KICKER_STYLE = {
  fontSize: "13px",
  lineHeight: "12px",
  fontWeight: 600,
  letterSpacing: ".08em",
  textTransform: "uppercase" as const,
};

/** KPI-cell label: the 11px variant of the kicker used in the strip. */
export const LABEL_STYLE = {
  fontSize: "11px",
  lineHeight: "12px",
  fontWeight: 600,
  letterSpacing: ".08em",
  textTransform: "uppercase" as const,
};
